export default "__VITE_ASSET__DDH1Ea5N__"